export default {
  page: {
    title: 'Word grouper',
    subtitle: 'Tools',
  },
  card: {
    title: 'Word grouper',
  },
  form: {
    wordsPerGroup: {
      label: 'Words',
      placeholder: 'Number of words per group',
    },
    groupsPerMagazine: {
      label: 'Groups',
      placeholder: 'Number of groups per magazine',
    },
    totalMagazines: {
      label: 'Magazines',
      placeholder: 'Number of magazines',
    },
    wordsList: {
      label: 'Word list',
    },
    totalWords: {
      label: 'Total words:',
    },
    magazine: {
      label: 'Magazine',
    },
    group: {
      label: 'Group',
    },
  },
  button: {
    shuffle: 'Shuffle word list',
    generate: 'Generate word groups',
    copyMagazine: 'Copy magazine words',
    copyWords: 'Copy words',
  },
  alert: {
    shuffled: 'List shuffled successfully',
    generated: 'Groups generated successfully',
    insufficientWords:
      '{count} more word is needed to form the groups | {count} more words are needed to form the groups',
  },
};
